import { isValid as isValidCpf } from '@fnando/cpf';
import { isValidCnpj } from './cnpj';
import { removeNonDigitsAndLettersFromString } from './basic';

export const validateCpfCnpj = (value) => {
  // Preserva as letras do CNPJ alfanumérico (uppercase); CPF é só dígitos.
  const limpo = removeNonDigitsAndLettersFromString(value)?.toUpperCase() ?? '';

  if (limpo.length === 11) {
    return isValidCpf(limpo) || 'CPF inválido';
  }

  if (limpo.length === 14) {
    return isValidCnpj(limpo) || 'CNPJ inválido';
  }

  return 'CPF/CNPJ inválido';
};
